import React from "react"
import {
  Checkbox as MUICheckbox,
  CheckboxProps as MUICheckboxProps,
} from "@mui/material"
import { MUIMappedCheckbox } from "./mantine/Checkbox.mantine"

export type CheckboxProps =
  | ({ new?: false } & MUICheckboxProps)
  | ({ new: true } & MUICheckboxProps)

export const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(
  (props, ref) =>
    props.new ? (
      <MUIMappedCheckbox {...props} ref={ref} />
    ) : (
      <MUICheckbox {...props} ref={ref} />
    ),
)

Checkbox.displayName = "Checkbox"

export default Checkbox
